const windowIsOpen = window.outerWidth > 768;

export default {
  windowIsOpen,
};
